import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';

export interface RectSelectOption {
  id: any;
  label: string;
}

@Component({
  selector: 'app-rect-select',
  templateUrl: './rect-select.component.html',
  styleUrls: ['./rect-select.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: RectSelectComponent,
      multi: true,
    },
  ],
})
export class RectSelectComponent implements ControlValueAccessor {
  @Input() options: RectSelectOption[];
  selectedOptionID: any;

  // Forms
  formChange: any;
  formTouched: any;

  constructor() {}

  selectOption(optionID: any) {
    this.selectedOptionID = optionID;

    if (this.formChange) {
      this.formChange(optionID);
    }
  }

  onOptionBlur() {
    if (this.formTouched) {
      this.formTouched();
    }
  }

  registerOnChange(fn: any) {
    this.formChange = fn;
  }

  registerOnTouched(fn: any) {
    this.formTouched = fn;
  }

  setDisabledState(d: boolean) {
    // not implemented
  }

  writeValue(value: any) {
    this.selectedOptionID = value;
  }
}
